<template>
  <div class="life-rights">
    <div class="box-title">
      <span class="cube small mr16"></span>
      <span class="cube mr20"></span>
      生活权益
      <span class="cube ml20"></span>
      <span class="cube small ml16"></span>
    </div>
    <div class="box-list">
      <div class="box-item">
        <img src="../images/icon_eleme@2x.png" class="item-icon">
        <div class="item-info">
          <div class="info-title">饿了么超级会员</div>
          <div class="info-sub-title">5折优惠</div>
        </div>
      </div>
      <div class="box-item">
        <img src="../images/icon_eleme@2x.png" class="item-icon">
        <div class="item-info">
          <div class="info-title">饿了么超级会员</div>
          <div class="info-sub-title">5折优惠</div>
        </div>
      </div>
      <div class="box-item">
        <img src="../images/icon_eleme@2x.png" class="item-icon">
        <div class="item-info">
          <div class="info-title">饿了么超级会员</div>
          <div class="info-sub-title">5折优惠</div>
        </div>
      </div>
      <div class="box-item">
        <img src="../images/icon_eleme@2x.png" class="item-icon">
        <div class="item-info">
          <div class="info-title">饿了么超级会员</div>
          <div class="info-sub-title">5折优惠</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LifeRights'
}
</script>

<style lang="less" scoped>
@import "../../../assets/less/mixin.less";

.main-box{
  padding: 40px 40px 0;
  .box-title{
    font-size: 32px;
    line-height: 45px;
    color: #FFD7A6;
    display: flex;
    justify-content: center;
    align-items: center;
    .cube{
      display: block;
      width: 12px;
      height: 12px;
      background-color: #FFD7A6;
      transform: rotate(45deg);
      &.small{
        width: 10px;
        height: 10px;
      }
      &.ml20{margin-left: 20px;}
      &.ml16{margin-left: 16px;}
      &.mr20{margin-right: 20px;}
      &.mr16{margin-right: 16px;}
    }
  }
  .box-list{
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    margin-top: 28px;
    .box-item{
      background: linear-gradient(180deg, #4F506E 0%, #3A3B53 100%);
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 25px 20px;
      border-radius: 16px;
      margin-bottom: 20px;
      .item-icon{
        width: 79px;
        height: 79px;
      }
      .item-info{
        display: flex;
        flex-direction: column;
        justify-content: center;
        margin-left: 20px;
        .info-title{
          color: #fff;
          font-size: 26px;
          line-height: 37px;
        }
        .info-sub-title{
          font-size: 20px;
          color: #FFD7A6;
          line-height: 28px;
        }
      }
    }
  }
}
</style>